import { useEffect, useState } from "react";
import { api } from "@/lib/api";
import { toast } from "sonner";
import { Play, ArrowsClockwise } from "@phosphor-icons/react";
import LoadedQuestions from "./LoadedQuestions";

export default function NKDailyAdmin() {
  const [state, setState] = useState(null);
  useEffect(() => { const tick = async () => { try { const r = await api.get("/admin/modes/status"); setState(r.data.daily); } catch { /* */ } }; tick(); const id = setInterval(tick, 8000); return () => clearInterval(id); }, []);

  const start = async () => {
    if (!confirm("Force-start NK Daily show now?")) return;
    try { await api.post("/daily/admin/start-now"); toast.success("Daily show started"); }
    catch (e) { toast.error(e.response?.data?.detail || "Failed"); }
  };

  return (
    <div className="space-y-6">
      <Heading title="NK Daily" subtitle="The main event. 15 live questions, perfectly synchronized." />
      {!state ? (
        <p className="text-nk-mute text-sm">Loading…</p>
      ) : (
        <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
          <Stat label="Status" value={state.state} />
          <Stat label="Questions loaded" value={(state.questions || []).length} />
          <Stat label="Current Q index" value={state.current_q_index ?? -1} />
          <Stat label="Scheduled for" value={state.scheduled_for ? new Date(state.scheduled_for).toLocaleString() : "—"} mono />
        </div>
      )}
      <div className="flex flex-wrap gap-2">
        <Btn onClick={start} Icon={Play} label="Start now" tone="accent" />
        <Btn onClick={() => { window.open("/daily", "_blank"); }} Icon={ArrowsClockwise} label="Open live show" tone="line" />
      </div>
      <LoadedQuestions mode="daily" />
    </div>
  );
}

export function Heading({ title, subtitle }) {
  return (
    <header className="hidden lg:block">
      <p className="font-mono text-[10px] text-nk-dim uppercase tracking-[0.18em]">Command Center</p>
      <h1 className="font-display text-3xl font-medium tracking-tight">{title}</h1>
      {subtitle && <p className="text-sm text-nk-mute mt-2">{subtitle}</p>}
    </header>
  );
}

export function Stat({ label, value, mono = false }) {
  return (
    <div className="nk-card p-4">
      <p className="text-[11px] text-nk-mute uppercase tracking-wider mb-1">{label}</p>
      <p className={`text-xl ${mono ? "font-mono text-sm" : "font-display font-medium"}`}>{value ?? "—"}</p>
    </div>
  );
}

export function Btn({ onClick, Icon, label, tone = "accent", testid, disabled = false }) {
  const cls = tone === "accent" ? "bg-nk-accent text-nk-bg hover:bg-nk-accentSoft"
    : tone === "gold" ? "bg-nk-gold text-nk-bg hover:opacity-90"
    : tone === "bad" ? "border border-nk-bad text-nk-bad hover:bg-nk-bad/10"
    : "border border-nk-line text-nk-mute hover:text-nk-text";
  return (
    <button data-testid={testid} onClick={onClick} disabled={disabled}
      className={`px-4 py-2 text-sm font-medium rounded-sm inline-flex items-center gap-2 transition-colors ${cls} disabled:opacity-50 disabled:cursor-not-allowed`}>
      {Icon && <Icon size={14} weight="bold" />}
      {label}
    </button>
  );
}
